export default function generatePassword () {
    const length = 8;
    const charset = "abcdefghkpqrstwxyz23456789";

    let password = "";
    for (let i = 0; i < length; i++){
        password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
}